import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {QrExporterService} from "../../../services/utils/qr-exporter.service";

@Component({
  selector: 'app-qr-exporter-modal',
  templateUrl: './qr-exporter-modal.component.html',
  styleUrls: ['./qr-exporter-modal.component.scss']
})
export class QrExporterModalComponent implements OnInit {

  constructor(
    public qrExporterService: QrExporterService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

}
